var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.552 511.552",
    style: {
      enableBackground: "new 0 0 511.552 511.552"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.464,
    y: 240,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.464,
    y: 240,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.776,196.688 429.152,219.312 449.84,240 352.464,240 352.464,272 449.84,272 429.152,292.688  451.776,315.312 511.088,256  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.464,0h-272v475.904L110.08,508.8c6.02,1.816,12.272,2.743,18.56,2.752c22.548,0.051,43.392-11.992,54.608-31.552 h89.216c26.51,0,48-21.49,48-48v-80h-32v80c0,8.837-7.163,16-16,16h-80c0-0.176,0-0.336,0-0.512V112.496 c0.084-26.199-15.882-49.776-40.24-59.424L99.536,32h172.928c8.837,0,16,7.163,16,16v112h32V48 C320.464,21.49,298.974,0,272.464,0z M140.352,82.8c12.178,4.815,20.16,16.601,20.112,29.696v334.992 c0.004,17.673-14.32,32.003-31.993,32.007c-3.118,0.001-6.22-0.454-9.207-1.351l-86.8-26.048V39.648L140.352,82.8z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.fd503a67aef37386c4fb7654035b7ecc.svg";
export { ForwardRef as ReactComponent };